import axios from 'axios';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Container from 'react-bootstrap/Container';
import Main from '../../../layouts/Main/Main';
import { IAddress } from '../../../types';
import { toast } from 'react-toastify';

const Addresses = () => {
  const [addresses, setAddresses] = useState<IAddress[]>([]);
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');

  const load = () => axios.get<IAddress[]>('/api/address').then((response) => setAddresses(response.data));

  useEffect(() => {
    load().catch(() => toast.error('Unable to load addresses'));
  }, []);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    axios
      .post('/api/address', { name, address })
      .then(() => {
        setName('');
        setAddress('');
        return load();
      })
      .catch((error) => toast.error(error.response?.data?.message ?? 'Unable to save address'));
  };

  const handleDelete = (id: string) => {
    axios.delete(`/api/address/${id}`).then(load).catch(() => toast.error('Unable to delete address'));
  };

  return (
    <Main breadcrumb={[{ name: 'Home', path: '/' }, { name: 'Addresses', path: '/addresses', active: true }]}>
      <Container className="mt-3">
        <Card className="mb-3">
          <Card.Header>Add an address</Card.Header>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-2">
                <Form.Label>Name</Form.Label>
                <Form.Control value={name} onChange={(event) => setName(event.target.value)} required />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Address</Form.Label>
                <Form.Control value={address} onChange={(event) => setAddress(event.target.value)} required />
              </Form.Group>
              <Button type="submit">Add</Button>
            </Form>
          </Card.Body>
        </Card>
        <Card>
          <Card.Header>Saved addresses</Card.Header>
          <ListGroup variant="flush">
            {addresses.map((item) => (
              <ListGroup.Item key={item._id} className="d-flex justify-content-between align-items-center">
                <span><strong>{item.name}</strong> - {item.address}</span>
                <Button variant="outline-danger" size="sm" onClick={() => handleDelete(item._id)}>Delete</Button>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card>
      </Container>
    </Main>
  );
};

export default Addresses;
